import React from 'react';
import TabellaGenerale from '../TabellaGenerale';

function Area730() {
    return (
        <TabellaGenerale titolo="Area 730" url="area730" nome="730" numTabella={4} />
    );
};

export default Area730;